import type { ToolResultMessageContent } from "schemas/chat";
import type { ChatMessage } from "schemas/generated/chatMessage";

export const findToolResult = (
  toolCallId: string,
  allMessages: ChatMessage[],
) => {
  const toolResultMessage = allMessages.find((message) => {
    if (message.role !== "tool") {
      return false;
    }

    return message.content.some(
      (item) => item.type === "tool-result" && item.toolCallId === toolCallId,
    );
  });

  const toolResult = toolResultMessage?.content.find(
    (item) => item.type === "tool-result" && item.toolCallId === toolCallId,
  ) as ToolResultMessageContent | null;

  const toolResultMessageId = toolResultMessage?.id;

  return {
    toolResult,
    toolResultMessageId,
  };
};
